import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AddCustomProductToBasket, type CustomDigitalGiftCardActionModel } from 'autogen/swagger/all';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';
import TextInput from 'components/shared/inputs/text';
import ReactButton, { ButtonStyle } from 'modules/react-button';
import Translations from 'modules/translations';
import { breakpoint, sizes } from 'variables';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px 50px 50px;

    ${breakpoint.up(sizes.md)} {
        padding: 10px 80px 50px;
        max-width: 600px;
    }
`;

const Top = styled.div`
    flex: 1;
    text-align: center;
    margin-bottom: 40px;
`;

const Bottom = styled.div`
    display: flex;
    flex-direction: column;
    align-item: center;
`;

const Heading = styled.h2`
    font-weight: bold;
`;

const SubHeading = styled.h3`
    font-weight: bold;
`;

const Image = styled(PictureDeprecated)`
    img {
        width: 200px;
        max-width: 100%;
        margin: 20px 0;
    }
`;

const Button = styled(ReactButton)`
    width: 100%;
    margin: 20px 0 0 0;
`;

export default function CustomGiftCard(props: CustomDigitalGiftCardActionModel): JSX.Element {
    const {
        title,
        header,
        description,
        inputFieldHeader,
        minAmount,
        maxAmount,
        productId,
        type,
        image,
        addToBasketType
    } = props;
    const [value, setValue] = useState<any>(minAmount);
    const [valid, setValid] = useState(true);

    useEffect(() => {
        setValid(Number(value) >= minAmount && Number(value) <= maxAmount);
    }, [maxAmount, minAmount, value]);

    useEffect(() => {
        setValue(value);
    }, [value]);

    function handleChange(event): void {
        const { target } = event;

        setValue(target.value);
    }

    function handleAddToBasket(): void {
        AddCustomProductToBasket({ productId, addToBasketType }, { Type: type, InputField_1: value }).then((result) => {
            if (result.redirectLinkAction) {
                window.location.href = result.redirectLinkAction.url;
            }
        });
    }

    function validateInput(): void {
        setValue(Math.min(Math.max(value, minAmount), maxAmount));
    }

    function clearInput(): void {
        setValue('');
    }

    return (
        <Wrapper>
            <Top>
                <Heading>{title}</Heading>
                <Image {...image} />
                <SubHeading>{header}</SubHeading>
                <div>{description}</div>
            </Top>
            <Bottom>
                <TextInput
                    label={inputFieldHeader}
                    pattern="[0-9]*"
                    value={value}
                    onChange={handleChange}
                    onBlur={validateInput}
                    onClick={clearInput}
                />
                <Button buttonStyle={ButtonStyle.primary} onClick={handleAddToBasket} disabled={!valid}>
                    {Translations.Website.Shared.Buttons.BuyNowDigitalProduct}
                </Button>
            </Bottom>
        </Wrapper>
    );
}
